.floatingDropdown {
  position: relative;
}


.colorAvatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .letters {
    font-size: 14px;
  }

  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 32px;
    width: 32px;
    transform: translate(-50%, -50%);
    animation: loader-1-1 4.8s linear infinite;
  }
  @keyframes loader-1-1 {
    0%   { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }
  .loader > span {
    display: block;
    position: absolute;
    top: 0; left: 0;
    bottom: 0; right: 0;
    margin: auto;
    height: 32px;
    width: 32px;
    clip: rect(0, 32px, 32px, 16px);
    animation: loader-1-2 1.2s linear infinite;
  }
  @keyframes loader-1-2 {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(220deg); }
  }
  .loader span::after {
    content: "";
    position: absolute;
    top: 0; left: 0;
    bottom: 0; right: 0;
    margin: auto;
    height: 32px;
    width: 32px;
    clip: rect(0, 32px, 32px, 16px);
    @include themify($themes) {
      border: 2px solid themed('main-primary');
    }

    border-radius: 50%;
    animation: loader-1-3 1.2s cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite;
  }
  @keyframes loader-1-3 {
    0%   { transform: rotate(-140deg); }
    50%  { transform: rotate(-160deg); }
    100% { transform: rotate(140deg); }
  }
}


.searchItems {
  width: 200px;
  position: absolute;
  top: calc(100% + 12px);
  transform: translate(50%, 0);
  right: 50%;
  box-shadow: 0px 15px 18px rgb(0 0 0 / 10%);
  border-radius: 24px;
  overflow: hidden;
  user-select: none;
  z-index: 3;

  @include themify($themes) {
    border: solid 1px themed("neutral-secondary");
    background-color: themed("main-secondary");
  }

  .searchInput {
    padding: 0;
    input {
      padding: 15px;
      border: none !important;
      height: auto !important;
      outline: none !important;
    }
  }
  .searchList {
    overflow: auto;
    max-height: 300px;
    margin-bottom: 10px;
  }

  .searchItem {
    display: flex;
    align-items: center;
    font-size: 13px;
    line-height: 20px;
    padding: 10px;

    .color {
      flex-shrink: 0;
      margin-right: 10px;
    }

    &.focused {
      @include themify($themes) {
        background: themed('neutral-tertiary');
      }
    }
  }
}



.groupUsers {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: relative;
  padding-right: 30px;

  .userColor {
    margin-right: -13px;
    transition: all 0.2s ease-in-out;
    width: 32px;
    height: 32px;

    @include themify($themes) {
      border: 2px solid themed('main-secondary');
    }

    > span, > svg {
      transition: all 0.2s ease-in-out;
      position: absolute;
    }
    > svg {
      transform: scale(0);
    }

    &:not(.disabled) {
      cursor: pointer;
    }

    &:hover:not(.disabled) {
      border-width: 3px;
      margin-right: -2px;
      margin-left: 5px;
      z-index: 1;
      transform: scale(1.2);

      > span {
        transform: scale(0);
      }
      > svg {
        transform: scale(1);
      }
    }
  }

  .addUser {
    position: relative;
    .addUserButton {
      margin-right: 0;
      cursor: pointer;
      @include themify($themes) {
        background: themed('neutral-tertiary') !important;
      }
    }
  }
}
